<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div *ngIf="showPage">
    <u><b>Please verify you details</b></u>

    <p>Hi {{userName}}.  Please enter the date below to verify your identity so you can view and sign your application</p>
    <p>Note: Three incorrect attempts will lock your application, and you will need to follow up with your agent.</p>
    <div class="col-8">
        <ValidatedTextField class="medicare-number"
                            [label]="'Medicare Number'"
                            [validators]="[notBlankValidator]" [text]="medicareNumber"
                            [disabled]="disabled" [maxlength]="20"
                            (onValueChange)="medicareNumber=$event">
        </ValidatedTextField>
        <br />
        <ValidatedTextField class="last-name"
                            [label]="'Last Name'"
                            [validators]="[notBlankValidator]"
                            [text]="lastName"
                            [disabled]="disabled"
                            (onValueChange)="lastName=$event">
        </ValidatedTextField>
        <br />

        <ValidatedDateTextField [label]="'Date of Birth :'"
                                id="dateofBirth"
                                [date]="DOB"
                                (onDateChange)="DOB = $event"
                                [validators]="[validatedDate,notBlankValidator]">
        </ValidatedDateTextField>
        <br />
        <div>
            <button id="verifyEAP" class="button primary" (click)="verify()">Verify</button>
        </div>
    </div>
    <div class="row" *ngIf="!isValid">
        <div class="col-24">
            <div><b>Error Message:</b></div>
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages">
                        <button [innerHtml]="error">
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
